import { Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { InputCmp } from '../../../../../components/InputCmp'
import { iItemFeedbackResponse } from '../../../../../interfaces'
import { converterData, converterDataEmString, GetNomeItemFeedback } from '../../../../../Utils/Helper'
import { TableDiv } from './styles'

interface iTabelaprops {
  rows: iItemFeedbackResponse[]
  dataInicioFeedback?: string
  iniciado?: boolean
  onChangeData: (changes: Array<{ id?: string, novaDataInicio?: string }>) => void
}

export const TableDataItens: React.FC<iTabelaprops> = ({ rows, dataInicioFeedback, onChangeData, iniciado }) => {
  const [Rows, setRows] = useState<iItemFeedbackResponse[]>([])

  function CheckDateIsInvalid(fase: number, ordem?: number, dataInicio?: string): boolean {
    if (!ordem || !dataInicio) return false
    let dataMinima: Date
    const arr = rows.filter(e => e.fase === 0 && e.dataInicio)
    if (fase === 1 && arr.length > 0) {
      dataMinima = converterData(arr[arr.length - 1].dataInicio ?? '')
    }
    if (fase === 1 && ordem) {
      rows.filter(e => e.fase === 1 && e.dataInicio).forEach(e => {
        if (converterData(e.dataInicio ?? '') > dataMinima && e.ordem && e.ordem < ordem) {
          dataMinima = converterData(e.dataInicio ?? '')
        }
      })
    }

    return rows.filter(e => e.fase === fase).some(r => r.ordem && r.dataInicio && ((r.ordem < ordem && converterData(dataInicio) < converterData(r.dataInicio)) || (fase === 1 && converterData(dataInicio) < dataMinima)))
  }

  useEffect(() => {
    if (dataInicioFeedback) {
      const copy: iItemFeedbackResponse[] = []
      rows.forEach((e) => {
        const item = { ...e }
        if (item.dataInicio && converterData(dataInicioFeedback) > converterData(item.dataInicio)) {
          item.dataInicio = dataInicioFeedback
        }
        copy.push(item)
      })
      onChangeData(copy.map(e => { return { id: e.id, novaDataInicio: e.dataInicio } }))
    }
  }, [dataInicioFeedback])

  useEffect(() => {
    setRows(rows)
  }, [rows])

  return (
    <TableDiv>
      <table>
        <thead>
          <tr>
            <th>
              Ordem
            </th>
            <th>
              Nome
            </th>
            <th>
              Etapa
            </th>
            <th>
              Data início
            </th>
            <th>
              Data fim
            </th>
          </tr>
        </thead>
        <tbody>
          {
            Rows.map((e, i) => {
              return (
                <tr key={`${i}-fase-${e.fase}`}>
                  <td>{e.ordem}</td>
                  <td>{e.nomeItem
                    ? <Flex flexDir={'column'} alignItems='center' justifyContent={'center'}>
                    <Text fontWeight={600}>{e.nomeItem}</Text>
                    <Text fontSize={'13px'} fontWeight={400} color={'var(--Gray2)'}>{GetNomeItemFeedback(e.tipo)}</Text>
                  </Flex>
                    : GetNomeItemFeedback(e.tipo)}</td>
                  <td>{e.fase === 0 ? 'Informações prévias' : 'Itens para condução'}</td>
                  <td>
                    <Flex justifyContent={'center'} alignItems='center' gap={'.5rem'} flexWrap={'wrap'}>
                      <InputCmp isDisabled={iniciado} min={dataInicioFeedback} value={e.dataInicio?.includes('T') ? e.dataInicio.split('T')[0] : e.dataInicio} type={'date'} OnChange={(val) => onChangeData([{ id: e.id, novaDataInicio: val }])} isInvalid={CheckDateIsInvalid(e.fase, e.ordem, e.dataInicio)}/>
                    </Flex>
                  </td>
                  <td>
                    {e.dataInicio ? converterDataEmString(e.dataInicio?.includes('T') ? e.dataInicio.split('T')[0] : e.dataInicio, e.prazoPreenchimento ?? 0) : `${e.prazoPreenchimento} dias para preencher`}
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </TableDiv>
  )
}
